var lookup = {exports: {}};

export { lookup as l };
